var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('oeamtc-select',{attrs:{"disabled":_vm.disabled,"value":_vm.valueIndex,"options":_vm.triplogOptions,"aria-name":"vehicle"},on:{"input":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }